



























































































































































import { Component, Vue } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import { ICurrentPage } from '~/store/types';
import AboutUsPrinciple from '~/components/About/AboutUsPrinciple.vue';
import AboutUsNewsArticle from '~/components/About/AboutUsNewsArticle.vue';
import AboutUsGames from '~/components/About/AboutUsGames.vue';
import AboutUsVisionary from '~/components/About/AboutUsVisionary.vue';
import AboutUsQuotes from '~/components/About/AboutUsQuotes.vue';
import AboutUsRotatingGlobe from '~/components/About/AboutUsRotatingGlobe.vue';
import AboutUsPartners from '~/components/About/AboutUsPartners.vue';

@Component({
  components: {
    AboutUsPrinciple,
    AboutUsNewsArticle,
    AboutUsGames,
    AboutUsVisionary,
    AboutUsQuotes,
    AboutUsRotatingGlobe,
    AboutUsPartners,
  },
})
export default class AboutPage extends Vue {
  @Mutation updateCurrentPage!: (payload: ICurrentPage) => void;

  heroImage = 'https://static.gala.games/images/about-page/hero_image_02.png';
  get principles() {
    return [
      {
        title: 'Fun First.',
        displayTitle: this.$t('pages.about.funFirst'),
        text: this.$t('pages.about.funFirstText'),
        imgSrc:
          'https://static.gala.games/images/about-page/townstar_rancher.png',
      },
      {
        title: 'Owned by Players.',
        displayTitle: this.$t('pages.about.ownedByPlayers'),
        text: this.$t('pages.about.ownedByPlayersText'),
        imgSrc: 'https://static.gala.games/images/about-page/mirandus_elf.png',
      },
      {
        title: 'Community Rules.',
        displayTitle: this.$t('pages.about.communityRules'),
        text: this.$t('pages.about.communityRulesText'),
        imgSrc:
          'https://static.gala.games/images/about-page/fortified_tower.png',
      },
      {
        title: 'Powered by the People.',
        displayTitle: this.$t('pages.about.poweredByThePeople'),
        text: this.$t('pages.about.poweredByThePeopleText'),
        imgSrc:
          'https://static.gala.games/images/about-page/mirandus_exemplar.png',
        linkText: 'Get yours today!',
        route: '/nodes',
      },
    ];
  }

  get newsArticles() {
    return [
      {
        title: 'NFTs Are Spurring a Digital Land Grab—in Videogame Worlds',
        displayedTitle: this.$t('pages.about.nftsAreSpurring'),
        text: this.$t('pages.about.nftsAreSpurringText'),
        imgSrc: 'https://static.gala.games/images/about-page/blog_img_01c.png',
        link:
          'https://www.wsj.com/articles/nfts-are-spurring-a-digital-land-grabin-videogame-worlds-11616414401',
      },
      {
        title:
          'Frank Miller taps Concept Art House and Gala Games for 30th anniversary Sin City NFT collectibles',
        displayedTitle: this.$t('pages.about.frankMiller'),
        text: this.$t('pages.about.frankMillerText'),
        imgSrc: 'https://static.gala.games/images/about-page/blog_img_02.jpg',
        link:
          'https://venturebeat.com/2021/04/29/frank-miller-taps-concept-art-house-and-gala-games-for-30th-anniversary-sin-city-nft-collectibles/',
      },
      {
        title:
          'Gala Games paves path for blockchain games in a deal with Brave',
        displayedTitle: this.$t('pages.about.galaGamesPaves'),
        text: this.$t('pages.about.galaGamesPavesText'),
        imgSrc: 'https://static.gala.games/images/about-page/blog_img_03c.png',
        link:
          'https://venturebeat.com/2020/12/04/gala-games-paves-path-for-blockchain-games-in-a-deal-with-brave-browser/',
      },
    ];
  }

  visionaries = [
    {
      title: 'Frank Miller',
      text: `American comic book writer, penciller and inker, novelist, screenwriter, film director, and producer best known for his comic book stories and graphic novels such as Daredevil: Born Again, The Dark Knight Returns, Sin City, and 300. Frank Miller has partnered with Gala Art and Concept Art House to release 30th Anniversary NFTs. `,
      imgSrc: 'https://static.gala.games/images/about-page/about_item_03.jpg',
    },
  ];

  get milestones() {
    return [
      {
        number: '$3M',
        text: this.$t('pages.about.ourMostExpensive'),
      },
      {
        number: '90+',
        text: `${this.$t(
          'pages.about.teamMembers.part1.string',
        )} <br />${this.$t('pages.about.teamMembers.part2.string')}`,
      },
      {
        number: '1.3M',
        text: this.$t('pages.about.monthlyActiveUsers'),
      },
      {
        number: '26K',
        text: `${this.$t(
          'pages.about.totalNftsSold.part1.string',
        )} <br />${this.$t('pages.about.totalNftsSold.part2.string')}`,
      },
    ];
  }

  async created() {
    this.updateCurrentPage({
      title: 'About',
      backIcon: 'arrow_back_ios',
      backRoute: `/`,
    });
  }

  mounted() {
    this.addLaxElements();
  }

  destroyed() {
    this.$lax.removeElements('.ecosystem-lax');
  }

  addLaxElements() {
    this.$lax.addElements('.ecosystem-lax', {
      scrollY: {
        translateY: [
          ['elInY-30', 'elCenterY'],
          [-130, 0],
        ],
      },
    });
  }

  goTo(route: string) {
    this.$router.push(route);
  }
}
